import "./App.css";

export default function Privacy() {
  return (
    <main className="app-bg">
      <div className="main-container">
        <section className="gc-container gc-hero">
          <h1>Privacy</h1>
          <p className="lead">
            Your privacy matters. This site is a client‑side application — most
            interactions happen in your browser. We aim to minimise data
            collection and store settings locally on your device.
          </p>
        </section>

        <section className="gc-container gc-policy">
          <h2>Where your data lives</h2>
          <ul>
            <li>
              <strong>No server-side storage</strong> — We do not persist user data on our
              servers. Preferences and recent activity can be kept in your
              browser's <code>localStorage</code>.
            </li>
            <li>
              <strong>Local assets</strong> — Item metadata, icons, and model files are shipped
              with the app (for example under <code>storage</code> and <code>assets</code>), so
              browsing core content works without sending personal data.
            </li>
          </ul>
        </section>

        <section className="gc-container gc-policy">
          <h2>Network requests and third parties</h2>
          <ul>
            <li>
              <strong>Warmane and Caverns of Time</strong> — When you look up characters or items,
              requests may be made to these services. Those requests are handled by your
              browser and subject to their respective policies.
            </li>
            <li>
              <strong>Analytics</strong> — We do not include analytics or tracking by default.
            </li>
          </ul>
        </section>

        <section className="gc-container gc-policy">
          <h2>Cookies and storage</h2>
          <ul>
            <li>
              <strong>Cookies</strong> — This site does not use cookies for tracking.
            </li>
            <li>
              <strong>Local storage</strong> — Settings and cached data may be stored locally in
              your browser. You can clear this at any time from your browser settings.
            </li>
          </ul>
        </section>

        <section className="gc-container gc-policy">
          <h2>Your choices</h2>
          <ul>
            <li><strong>Clear local data</strong> — Clear site data from your browser.</li>
            <li><strong>Open development</strong> — Review or contribute code and metadata in the
              repository to improve transparency and correctness.</li>
          </ul>
        </section>

        <section className="gc-container gc-policy">
          <h2>Children's privacy</h2>
          <p>
            This site is not directed to children under 13. If you believe we have any
            information about a child, contact us and we will remove it.
          </p>
        </section>

        <section className="gc-container gc-policy">
          <h2>Changes to this policy</h2>
          <p>
            We may revise this page from time to time. Material changes will be reflected
            here with an updated date.
          </p>
        </section>

        <section className="gc-container gc-contact">
          <h2>Questions or concerns?</h2>
          <p>
            Reach out on our Discord (link in the footer). We're happy to clarify how the
            app works and how your data is handled.
          </p>
        </section>
      </div>
    </main>
  );
}
